const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return null;

  return usdFormatter.format(amount);
};

export const formatCentsAsCurrency = (amountCents) => {
  if (amountCents === null || amountCents === undefined) return null;

  return formatCurrency(amountCents / 100);
};

export const parseCurrencyAmountToCents = (value) => {
  if (value === "") return null;
  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) return null;

  const amount = Number(value);
  if (!Number.isFinite(amount) || amount < 0) return null;

  return Math.round(amount * 100);
};
